import Image from "next/image";

type MarkerProps = {
  lat: number;
  lng: number;
};

const MarkerIcon = ({ lat, lng }: MarkerProps) => {
  return (
    <div className="w-[100px] h-[100px] bg-[#bcdde0] flex justify-center items-center rounded-full opacity-60">
      <div className="w-[15px] h-[15px] bg-[#0089ff] rounded-full opacity-100"></div>
    </div>
  );
};

export default MarkerIcon;
